/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {makeStyles} from '@material-ui/core';
import {getAccordionWrapperStyles} from '@ion/dls/src/components/accordion/Accordion';
import {dlsColor, dlsLayout, dlsTypography} from '@ion/dls/src/theme/theme';
import {DLSTheme} from '@ion/dls/src/types/types';

export const useStyles = makeStyles((theme: DLSTheme) => {
  const padding = dlsLayout('gutters', 'mobile');
  return {
    content : {
      paddingLeft  : padding,
      paddingRight : padding + 10,
      paddingTop   : 0
    },
    assetDetails : {
      ...dlsTypography('panelCards'),
      fontFamily    : 'Roboto',
      fontWeight    : '600',
      fontSize      : '14px',
      lineHeight    : '17px',
      textTransform : 'uppercase',
      color         : dlsColor('black'),
      minHeight     : 48
    },
    assetCardListContentWrapper : {
      padding : '0px 15px'
    },
    detailsRoot : {
      display : 'block',
      padding : '0px'
    },
    assetDetailAccordion : {
      padding : '0 15px'
    },
    ...getAccordionWrapperStyles()
  };
});
